/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

// One stage in a daily-plan run's diagnostics timeline. `stage` is a plain string
// (not an enum) so a future stage never throws on an old client.
export const autopilotPlanStepSchema = z.object({
  stage: z.string(),
  ok: z.boolean(),
  detail: z.string(),
  at: z.number(),
});

export type IAutopilotPlanStep = z.infer<typeof autopilotPlanStepSchema>;

const autopilotTodaySchema = z.object({
  planDate: z.string(),
  status: z.string(),
  error: z.string().nullable().optional(),
  diagnostics: z.array(autopilotPlanStepSchema).optional().default([]),
  awaitingRender: z.number(),
  scheduled: z.number(),
  publishing: z.number(),
  published: z.number(),
  skipped: z.number(),
  failed: z.number(),
});

const autopilotRecentPlanSchema = z.object({
  planDate: z.string(),
  status: z.string(),
  scheduledCount: z.number(),
  error: z.string().nullable().optional(),
});

const autopilotStatusDataSchema = z.object({
  enabled: z.boolean(),
  today: autopilotTodaySchema.nullable(),
  recentPlans: z.array(autopilotRecentPlanSchema),
});

export type IAutopilotToday = z.infer<typeof autopilotTodaySchema>;
export type IAutopilotRecentPlan = z.infer<typeof autopilotRecentPlanSchema>;

export interface IAutopilotStatusData {
  enabled: boolean;
  today: IAutopilotToday | null;
  recentPlans: IAutopilotRecentPlan[];
}

export const getAutopilotStatusV1ResponseSchema = createApiResponseSchema(
  autopilotStatusDataSchema,
) as z.ZodSchema<IAPI<IAutopilotStatusData>>;

export type IGetAutopilotStatusV1Response = IAPI<IAutopilotStatusData>;
